import { BrowserRouter as Router, Route, Routes,Navigate   } from 'react-router-dom';

import './assets/css/App.css';
import './assets/css/theme.css'
import 'react-toastify/dist/ReactToastify.css';






import Index_Login_Register from './pages/Login_Register/Index_Login_Register';
import Select_User_Type_View from './pages/Select_User_Type/Select_User_Type_View';
import Requirements from './pages/Requirements/Requirements';
import Products from './pages/Products/Products';
import Single_product from './pages/Single_product/Single_product';
import Contact_us from './pages/Internal_pages/Contact_us';
import Services from './pages/Internal_pages/Services';
import Home from './pages/Home/Home';
import { Helmet } from 'react-helmet';

import Login_Message from './pages/Login_Message/index';





/////// Start route User simpale

import Request_Reg from './pages/panel/Requests/Request_Reg';
import List_My_Requests from './pages/panel/Requests/List_My_Requests';
import Suggested_vendors from './pages/panel/Suggested_vendors/Suggested_vendors';

import Product_Reg from './pages/panel/Products/Product_Reg';
import Product_Edit from './pages/panel/Products/Product_Edit';
import List_My_Products from './pages/panel/Products/List_My_Products';

import My_Dashboard from './pages/panel/My_Dashboard';






import Profile_Edit from './pages/panel/Profile_Edit/Profile_Edit';
import Comments from './pages/panel/Comments/Comments';
import Authentication_Documents from './pages/panel/Authentication_Documents/Authentication_Documents';
import Tickets_Messages_View from './pages/panel/Tickets/Tickets_Messages_View';





import Change_password from "./pages/panel/Change_password";

/////// End route User simpale


import About_Us from "./pages/Internal_pages/About_Us";



 function App() {


  if (!localStorage.getItem('cart')) {
    localStorage.setItem('cart' , JSON.stringify([]))
    localStorage.setItem('price' , 0)
  }

  if (!localStorage.getItem('themes_status')) {
    localStorage.setItem("themes_status","white");
  }

     const currentUrl = window.location.href; // گرفتن URL فعلی

  return (
      <div className="App">
          <Helmet>
              <link rel="canonical" href={currentUrl} />
          </Helmet>
       <Router>

      {/*<Router basename={"/bazar/"}>*/}



        <Routes>

            <Route path="/" element={<Home />}></Route>


            <Route path="/switch-panel/:type_user_login_reg" element={<Select_User_Type_View />}></Route>

            <Route path="/requirements/" element={<Requirements />}></Route>
            <Route path="/requirements/:id_cat_getuser" element={<Requirements />}></Route>


            <Route path="/products/" element={<Products />}></Route>
            <Route path="/product-category/*" element={<Products />}></Route>
            <Route path="/product/:post_id" element={<Single_product />}></Route>



            <Route path="/contact-us/" element={<Contact_us />}></Route>
            <Route path="/about-us/" element={<About_Us />}></Route>
            <Route path="/services/" element={<Services />}></Route>




          <Route path="/login-register" element={<Index_Login_Register />} />
          <Route path="/login-register/:type_user_login_reg" element={<Index_Login_Register />} />
          <Route path="/login" element={<Index_Login_Register />} />



        {/*  Start route User simpale  */}

            <Route path="/panel/dashboard" element={<My_Dashboard />} />
            <Route path="/panel" element={<Navigate to="/panel/dashboard" />} />

            <Route path="/panel/requests" element={<List_My_Requests />} />
            <Route path="/panel/request-reg" element={<Request_Reg />} />


            <Route path="/panel/suggested-vendors" element={<Suggested_vendors />} />



            <Route path="/panel/my-products" element={<List_My_Products />} />
            <Route path="/panel/product-edit/:post_id" element={ <Product_Edit /> } />
            <Route path="/panel/product-registration" element={ <Product_Reg /> } />





            <Route path="/panel/profile" element={<Profile_Edit />} />

            <Route path="/panel/authentication" element={<Authentication_Documents />} />


            <Route path="/panel/tickets/" element={<Tickets_Messages_View />} />
            <Route path="/panel/tickets/:id_ticket" element={<Tickets_Messages_View />} />

            <Route path="/panel/comments" element={<Comments />} />


            {/*<Route path="/panel/change-password" element={<Change_password />} />*/}







            {/*  End route User simpale  */}





            <Route path="*" element={"404 Not Found"} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
